import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import './SingleLogout.scss';
import * as messageConstants from '../../../shared/messages';

class SingleLogout extends Component {
  static propTypes = {
    isSingleLogoutEnabled: PropTypes.bool,
    logoutRedirectUri: PropTypes.string,
    updateIsSingleLogoutEnabled: PropTypes.func,
    updateLogoutRedirectUri: PropTypes.func,
  }

  handleToggleSingleLogout = (e) => {
    this.props.updateIsSingleLogoutEnabled(e.target.checked);
  }

  handleUpdateLogoutRedirectUri = (e) => {
    this.props.updateLogoutRedirectUri(e.target.value);
  }

  render() {
    const isChecked = Boolean(this.props.isSingleLogoutEnabled);
    return (
        <div className="pt-31">
          <p className="sba-subtitle">
            {messageConstants.OIDC_SINGLE_LOGOUT_TITLE}
          </p>
          &nbsp;
          <div className="copy-row">
            <input id="isSingleLogoutEnabled" type="checkbox"
                   className="public-client-checkbox"
                   checked={isChecked}
                   value={isChecked}
                   onChange={this.handleToggleSingleLogout}/>
            <div className="public-client-column">
              <label htmlFor="isSingleLogoutEnabled" className="public-client-label">
                {messageConstants.OIDC_SINGLE_LOGOUT_ENABLE_LABEL}
              </label>
            </div>
          </div>

          <div className="single-logout-uri">
            <label htmlFor="logoutRedirectUri" className="add-edit-subtitle">
              {messageConstants.OIDC_LOGOUT_REDIRECT_URI_TITLE}
            </label>
            <input id="logoutRedirectUri" type="text"
                   className="redirect-uri-input form-control attributes-input"
                   value={this.props.logoutRedirectUri || ''}
                   placeholder={messageConstants.OIDC_LOGOUT_REDIRECT_URI_PLACEHOLDER}
                   disabled={!isChecked}
                   required={isChecked}
                   onChange={this.handleUpdateLogoutRedirectUri}/>
          </div>
        </div>
    );
  }
}

export default SingleLogout;
